import { FunctionComponent } from "react";

import LightBulb from "@/assets/icons/light-bulb.svg";
import { Mention } from "@/types/Mention";

import styles from "./Topic.module.css";

export type TopicProps = {
  className?: string;
  mention: Mention;
};

const Topic: FunctionComponent<TopicProps> = ({ className, mention }) => {
  const topics = mention.topic_names;
  return topics && topics.length > 0 ? (
    <div className={className}>
      <span data-testid="topics-indicator" className={styles.topic}>
        <LightBulb height={18} width={18} className={styles.icon} />
        {topics?.map((topic, index, arr) => (
          <span key={topic}>
            {topic}
            {index < arr.length - 1 ? ", " : ""}
          </span>
        ))}
      </span>
    </div>
  ) : null;
};

export default Topic;
